import { CSSProperties } from "@material-ui/core/styles/withStyles";
import {
  size,
  weight,
  lineHeight,
  fontFamily,
} from "@clockwise/web-commons/src/styles/type.styles";
import { greys, colors } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { CHROME_MAX_WIDTH } from "@components/chrome-wrapper/ChromeWrapper.styles";

const container: CSSProperties = {
  position: "relative",
  borderRadius: 8,
  marginTop: 16,
  background: greys.white,
  boxShadow: `rgba(0, 0, 0, .12) 0 0 2px 0, rgba(0, 0, 0, .24) 0 2px 2px 0`,
  backgroundColor: greys.white,
  transition: "all .35s",
};

export const expandedContainer: CSSProperties = {
  ...container,
  position: "absolute",
  zIndex: 7,
  left: 12,
  right: 14,
  maxHeight: "70vh",
  overflowX: "visible",
  overflowY: "auto",
};

export const collapsedContainer: CSSProperties = {
  position: "relative",
};

export const confirmationContainer: CSSProperties = {
  ...container,
};

export const collapsed = {
  container: {
    borderRadius: "25px",
  },
  button: {
    height: "48px",
    borderRadius: "25px",
  },
  overlay: {
    height: "48px",
    borderRadius: "25px",
    lineHeight: "48px",
  },
  label: {
    fontFamily,
    fontWeight: weight.bold,
    textTransform: "uppercase",
    marginTop: 1,
    color: greys.standard,
  } as CSSProperties,
};

export const expanded: CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  padding: "10px 12px 15px",
  overflowX: "hidden",
  overflowY: "auto",
};

export const expandedBackground: CSSProperties = {
  position: "absolute",
  zIndex: 6,
  right: 0,
  left: 0,
  height: "100%",
  background: "rgba(238, 240, 241, 0.9)",
};

export const taller: CSSProperties = {
  height: 500,
  marginBottom: -250,
};

export const header: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
};

export const avatar = {
  borderRadius: "50%",
  height: 30,
  width: 30,
  border: "2px solid white",
  marginLeft: -10,
};

export const tipContainer: CSSProperties = {
  width: "100%",
  marginTop: spacing.xs,
  backgroundColor: greys.white,
  boxShadow: `rgba(0, 0, 0, .12) 0 0 2px 0, rgba(0, 0, 0, .24) 0 2px 2px 0`,
  borderRadius: 6,
  padding: "15px 10px",
  cursor: "pointer",
  border: `1px solid ${greys.blueGrey}`,

  /* Position the tooltip */
  position: "absolute",
  zIndex: 50,
};

export const arrow = {
  background: {
    width: 0,
    height: 0,
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: `10px solid ${greys.blueGrey}`,
    position: "absolute",
    top: "-10px",
    right: 10,
  } as CSSProperties,
  foreground: {
    width: 0,
    height: 0,
    borderLeft: "9px solid transparent",
    borderRight: "9px solid transparent",
    borderBottom: `9px solid ${greys.white}`,
    position: "absolute",
    left: -9,
    bottom: -10,
  } as CSSProperties,
};

export const tipHeader: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginBottom: 8,
};

export const tipBody: CSSProperties = {
  fontSize: size.md,
  lineHeight: lineHeight.std,
};

export const bold: CSSProperties = {
  fontWeight: weight.bold,
};

export const checkbox = {
  style: {
    marginTop: 15,
    marginBottom: 15,
  } as CSSProperties,
  labelStyle: {
    fontSize: 14,
  } as CSSProperties,
  iconStyle: {
    marginRight: 10,
  } as CSSProperties,
};

export const confirmation = {
  container: {
    backgroundColor: greys.white,
    position: "absolute",
    zIndex: 15,
    borderTop: `1px solid ${greys.cloudyBlue}`,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    padding: 12,
    fontSize: size.md,
    color: greys.slate,
  } as CSSProperties,
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  } as CSSProperties,
  check: {
    htmlColor: colors.green.standard,
    style: {
      marginRight: spacing.sm,
    } as CSSProperties,
  },
  h2: {
    color: colors.blueDusk.standard,
    marginBottom: 0,
  } as CSSProperties,
};

export const businessIcon = {
  style: {
    height: 18,
    width: 18,
    marginRight: 10,
    flexShrink: 0,
  } as CSSProperties,
  htmlColor: greys.slate,
};

export const underlineStyle: CSSProperties = {
  visibility: "hidden",
};

const fab: CSSProperties = {
  backgroundColor: colors.green.darker,
  color: greys.white,
  fontWeight: "bold",
  width: "100%",
  "&:hover": {
    backgroundColor: colors.green.standard,
  },
};

const tutorialFabContainer: CSSProperties = {
  position: "fixed",
  width: CHROME_MAX_WIDTH,
  right: 0,
  bottom: 0,
  zIndex: 11,
  padding: 12,

  "&.webapp": {
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
};

export const styles = {
  fab,
  tutorialFabContainer,
};
